export enum FuaAssessmentSections {
  ASSESSMENT_OVERVIEW = 'assessment-overview',
  CERT_PERIOD_RECAP = 'cert-period-recap',
  SKILLED_NEEDS = 'skilled-needs',
  ADL_NEEDS = 'adl-needs',
  DISCHARGE_PLANNING = 'discharge-planning',
  AUTHORIZATION = 'authorization',
  PLAN_OF_CARE = 'plan-of-care',
  VISIT_SCHEDULING = 'visit-scheduling',
  MEDICATIONS = 'medications',
  VITALS = 'vitals',
  MEDICAL_BACKGROUND = 'medical-background',
  SUPERVISORY_REVIEW = 'supervisory-review',
  NARRATIVE = 'narrative',
  FINAL_STEPS = 'final-steps'
}

export const FuaAssessmentAnchors = [
  {
    key: FuaAssessmentSections.ASSESSMENT_OVERVIEW,
    href: '#assessment-overview',
    title: 'Assessment Overview'
  },
  {
    key: FuaAssessmentSections.SKILLED_NEEDS,
    href: '#skilled-needs',
    title: 'Skilled Needs'
  },
  {
    key: FuaAssessmentSections.ADL_NEEDS,
    href: '#adl-needs',
    title: 'ADL Needs'
  },
  {
    key: FuaAssessmentSections.DISCHARGE_PLANNING,
    href: '#discharge-planning',
    title: 'Discharge Planning'
  },
  {
    key: FuaAssessmentSections.AUTHORIZATION,
    href: '#authorization',
    title: 'Authorization'
  },
  {
    key: FuaAssessmentSections.VISIT_SCHEDULING,
    href: '#visit-scheduling',
    title: 'Visit Scheduling'
  },
  {
    key: FuaAssessmentSections.PLAN_OF_CARE,
    href: '#plan-of-care',
    title: 'Plan of Care'
  },
  {
    key: FuaAssessmentSections.SUPERVISORY_REVIEW,
    href: '#supervisory-review',
    title: 'Supervisory Review'
  },
  {
    key: FuaAssessmentSections.MEDICATIONS,
    href: '#medications',
    title: 'Medications'
  },
  {
    key: FuaAssessmentSections.VITALS,
    href: '#vitals',
    title: 'Vitals'
  },
  {
    key: FuaAssessmentSections.MEDICAL_BACKGROUND,
    href: '#medical-background',
    title: 'Medical Background'
  },
  {
    key: FuaAssessmentSections.NARRATIVE,
    href: '#narrative',
    title: 'Narrative'
  },
  {
    key: FuaAssessmentSections.FINAL_STEPS,
    href: '#final-steps',
    title: 'Final Steps'
  }
]

export enum ReasonForDocumentationValues {
  CHANGE_IN_CONDITION = 'change-in-condition',
  REAUTHORIZATION = 'reauthorization',
  CREATE_ACUTE_PERIOD = 'create-acute-period',
  UPDATE_ACUTE_PERIOD = 'update-acute-period',
  REVISION_TO_POC = 'revision-to-poc'
}

export const REASON_FOR_DOCUMENTATION_OPTIONS = [
  {
    label: 'Change in condition',
    value: ReasonForDocumentationValues.CHANGE_IN_CONDITION
  },
  {
    label: 'Reauthorization',
    value: ReasonForDocumentationValues.REAUTHORIZATION
  },
  {
    label: 'Create Acute period',
    value: ReasonForDocumentationValues.CREATE_ACUTE_PERIOD
  },
  {
    label: 'Update Acute period',
    value: ReasonForDocumentationValues.UPDATE_ACUTE_PERIOD
  },
  {
    label: 'Revision to POC',
    value: ReasonForDocumentationValues.REVISION_TO_POC
  }
]

export const ACUTE_PERIOD_REASONS = [
  ReasonForDocumentationValues.CREATE_ACUTE_PERIOD,
  ReasonForDocumentationValues.UPDATE_ACUTE_PERIOD
]

// All FUA sections use the uncontrolled architecture
export const UNCONTROLLED_FORM_SECTION: Set<FuaAssessmentSections> = new Set([
  FuaAssessmentSections.ASSESSMENT_OVERVIEW,
  FuaAssessmentSections.AUTHORIZATION,
  FuaAssessmentSections.CERT_PERIOD_RECAP,
  FuaAssessmentSections.SKILLED_NEEDS,
  FuaAssessmentSections.ADL_NEEDS,
  FuaAssessmentSections.DISCHARGE_PLANNING,
  FuaAssessmentSections.PLAN_OF_CARE,
  FuaAssessmentSections.VISIT_SCHEDULING,
  FuaAssessmentSections.MEDICATIONS,
  FuaAssessmentSections.VITALS,
  FuaAssessmentSections.MEDICAL_BACKGROUND,
  FuaAssessmentSections.SUPERVISORY_REVIEW,
  FuaAssessmentSections.NARRATIVE,
  FuaAssessmentSections.FINAL_STEPS
])
